import React from 'react';
import styled from 'styled-components';
import { spacer16, spacer24, Type } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, TWO_COLUMN_MAX_WIDTH, withAnimationContext, } from '../../../ui';
import { HeroLayout } from '../HeroLayout';
import { ResponsiveBodyType } from '../ResponsiveBodyType';
const Supertext = withAnimationContext(styled(Type.p).attrs({
    variant: 'balladBold',
}) `
    ${fadeInAnimation(DELAYS.FIRST)};
    text-transform: uppercase;
    margin-bottom: ${spacer24};
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      margin-bottom: ${spacer16};
    }
  `);
const Body = withAnimationContext(styled(ResponsiveBodyType) `
    ${fadeInAnimation(DELAYS.SECOND)};
  `);
export const HeroNarrativeTextModule = React.forwardRef(({ supertext = '', body = '', image, layout = 'imageLeft', colors }, ref) => {
    return (React.createElement(HeroLayout, { image: image, layout: layout, colors: colors, ref: ref },
        supertext && React.createElement(Supertext, null, supertext),
        React.createElement(Body, { noImage: !image }, body)));
});
//# sourceMappingURL=index.js.map